import {forwardRef, useImperativeHandle, useState} from "react";
import {t} from "i18next";
import {ipcSend} from "@/common/ipc";
import {DEBUG} from "@/electron_interactive";
import {isZh} from "@/language";
import {isDarkMode} from "@/utils";
import {HOME_LEFT_MENU_WIDTH} from "@/Const";

const DialogUpdateAvaliable = forwardRef((props:{hasFreeUserUpgradeTip:boolean,onCloseEvent:any}, ref)=>{
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog
    }))

    const [version,setVersion] = useState('');
    const onShowDialog = (szVersion:string)=>{
        setVersion(szVersion)
    }

    /**
     * 太多不方便判断，----
     */
    const getMarginBottom = ()=>{
        if (props.hasFreeUserUpgradeTip){
            if (isZh()){
                return '200px';
            }
            return '218px';
        }
        return '58px';
    }
    return(
        <>
            {
                <div className={'update-avaliable-test'} style={{
                    background: 'var(--update-avaliable-background)',
                    position: "absolute",
                    left: '9px',
                    zIndex: '9',
                    bottom: getMarginBottom(),
                    width: `${HOME_LEFT_MENU_WIDTH - 22}px`,
                    minHeight: '118px',
                    padding: '12px',
                    borderRadius: '8px',
                    fontSize: '12px',
                    border: '1px solid var(--update-avaliable-border)'
                }}>
                    <span className={'dialog-title font-family-semi-bold'}>{t("NewUpdateAvaliable")}</span>
                    <div className={'mt-8'}>
                        <span style={{color:isDarkMode()?'#6D7986':'#333333'}}>{t("Version") + " " + version}</span>
                    </div>
                    <div className={'cursor-pointer'} onClick={() => {
                        if (isZh()) {
                            ipcSend('open-url', import.meta.env.VITE_HTTP_CHANGE_LOG_ZH);
                        } else {
                            ipcSend('open-url', import.meta.env.VITE_HTTP_CHANGE_LOG);
                        }

                    }} style={{marginLeft: '0px', textDecoration: 'underline',marginTop:'6px',color:isDarkMode()?'#6D7986':'#333333'}}>{t("See whats new")}</div>
                    <div className={'flex-row-vertical-center mt-16'}
                         style={{display: 'grid', gridTemplateColumns: '1fr 1fr'}}>
                        <div className={'button-border-gray-style flex-center'} onClick={() => {
                            if (props.onCloseEvent) {
                                props.onCloseEvent();
                            }
                        }}
                             style={{height: '34px', border: `1px solid ${isDarkMode()?'#556C92':'#A0BAE7'}`,borderRadius:'12px'}}>
                            {t("Later")}
                        </div>
                        <div className={'button-solid-style flex-center ml-10 font-family-medium'}
                             style={{height: '34px', background: '#3C84F6',color:isDarkMode()?'black':'white',borderRadius:'12px'}} onClick={() => {
                            ipcSend('start-install')
                        }}>
                            {t("Update")}
                        </div>
                    </div>
                </div>
            }
        </>

    )
})

export default DialogUpdateAvaliable;